import React from "react";

import { useCookies } from "react-cookie";
import Link from "gatsby-link";

import { CookieContainer } from "./CookieBar.styles";

const CookieBar = (props) => {
  //PROPS
  const { translations } = props;
  //PROPS

  //COOKIES
  const [cookies, setCookie] = useCookies(["hasCookiesDEV"]);
  //COOKIES

  //FUNCS
  const handleCookie = () => {
    setCookie("hasCookiesDEV", "true", { path: "/" });
  };
  //FUNCS

  //DEFS
  const lang = translations && translations[0]?.language.code;
  //DEFS

  if (cookies.hasCookiesDEV !== "true") {
    return (
      <CookieContainer>
        <div className="container">
          <p>
            As cookies servem para ajudar o website a funcionar corretamente e
            melhorar a sua experiência de navegação. Clique em "Aceitar Cookies"
            para avançar.
            <Link
              to={
                lang === "EN"
                  ? "/politica-de-privacidade/"
                  : "/en/privacy-policy"
              }
            >
              Para mais informações clique aqui
            </Link>
            .
          </p>
          <button onClick={() => handleCookie()}>Aceitar Cookies</button>
        </div>
      </CookieContainer>
    );
  } else {
    return null;
  }
};

export default CookieBar;
